
const state = {
  mode1: false,
  mode2: false,
  step: 'chaxun'
}
const mutations = {
  setMode1(state, payload) {
    state.mode1 = payload
  },
  setMode2(state, payload) {
    state.mode2 = payload
  },
  setStep(state, payload) {
    state.step = payload
  }
}
const getters = {
  title(state) {

    const { step } = state
    if (step === 'chaxun') {
      return "创建/加入企业"
    }
    if (step === 'chuangjian') {
      return "创建企业"
    }
    if (step === 'jiaru1') {
      return "加入企业"
    }
    if (step === 'jiaru2') {
      return "加入企业"
    }
    if (step === 'jiaru3') {
      return "加入企业"
    }
  },
}
const actions = {
  showMode1({ commit,dispatch }) {
    commit('setMode1', true)
    dispatch("app/setUserDrawerShow", false, { root: true })
  },
  hideMode1({ commit }) {
    commit("setMode1", false)
  },
  showMode2({ commit }) {
    commit('setMode2', true)
  },
  hideMode2({ commit }) {
    commit("setMode2", false)
  },
  setStep({ commit }, payload) {
    commit('setStep', payload)
  }
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}